export const GET_EVENT_REGISTRATION_FIELDS = 'GET_EVENT_REGISTRATION_FIELDS';
export const SET_ED_RESPONSE = 'SET_ED_RESPONSE';
export const GET_AVAILABILITY_DATES = "GET_AVAILABILITY_DATES";
export const GET_GLOBALLIMIT_AVAILABILITY = "GET_GLOBALLIMIT_AVAILABILITY";
export const POST_FORM = "POST_FORM";
export const SUBMIT_GLOBAL_LIMIT = "SUBMIT_GLOBAL_LIMIT";
